import type { JSX } from 'react';

import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

type Props = Readonly<{
	onClick?: () => void;
}>;

export function SkipToMainContentButton({ onClick }: Props): JSX.Element {
	return (
		<nav aria-labelledby="skip-to-main-content">
			<Button
				variant="secondary-solid"
				size="x-small"
				className="sr-only absolute left-2 top-2 z-10 focus:not-sr-only focus:!absolute focus:px-3 focus:py-2"
				id="skip-to-main-content"
				onClick={onClick}
				data-testid="skip-to-main-content"
				data-qa="skip-to-main-content"
			>
				<Translate value="fe.components.header.skip_to_main_content" />
			</Button>
		</nav>
	);
}
